export default __webpack_public_path__ + "static/media/arrow-down-circle-fill.71d45b46.svg";